/**
 * Ajoute la classe `is-inview` aux éléments reveal quand ils entrent dans le viewport.
 * Les styles (u-appear, u-opacity, u-cover, sections data-reveal) sont gérés en CSS.
 */
const SELECTOR =
	".u-appear, .u-opacity, .u-cover, .ls-appear, .ls-opacity, .ls-cover, [data-reveal]";

export default class ScrollReveal {
	constructor() {
		this.items = [...document.querySelectorAll(SELECTOR)];
		if (!this.items.length) return;

		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					entry.target.classList.add("is-inview");
					this.observer.unobserve(entry.target);
				});
			},
			{ rootMargin: "0px 0px -12% 0px" }
		);

		this.items.forEach((el) => {
			// Les éléments déjà visibles au chargement (above the fold) sont
			// révélés immédiatement : ils tombent souvent dans la zone morte
			// du rootMargin (bas de viewport) et ne se déclencheraient qu'au scroll.
			if (el.getBoundingClientRect().top < window.innerHeight) {
				el.classList.add("is-inview");
				return;
			}
			this.observer.observe(el);
		});
	}

	destroy() {
		this.observer?.disconnect();
	}
}
